import { render, staticRenderFns } from "./FormulationRationalisationDuplicatePopUp.vue?vue&type=template&id=6bdecff0&scoped=true&"
import script from "./FormulationRationalisationDuplicatePopUp.vue?vue&type=script&lang=js&"
export * from "./FormulationRationalisationDuplicatePopUp.vue?vue&type=script&lang=js&"
import style0 from "./FormulationRationalisationDuplicatePopUp.vue?vue&type=style&index=0&id=6bdecff0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdecff0",
  null
  
)

export default component.exports